import { createSlice } from "@reduxjs/toolkit";
import {
  AddSubscriptionAction,
  DeleteSubscriptionAction,
  GetAllPlanHistory,
  GetAllSubscriptionAction,
  UpdateSubscriptionAction,
} from "store/middlewares/SubscriptionPlans";

export const SubscriptionPlanSlice = createSlice({
  name: "subscription",
  initialState: {
    subscriptionLoading: false,
    subscription: [],
    planHistoryLoading: true,
    planHistory: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      // .addCase(GetAllSubscriptionAction.pending, (state) => {
      //   state.subscriptionLoading = true;
      //   state.subscription = [];
      // })
      // .addCase(GetAllSubscriptionAction.fulfilled, (state, action) => {
      //   state.subscriptionLoading = false;
      //   state.subscription = action.payload.response;
      // })
      // .addCase(GetAllSubscriptionAction.rejected, (state) => {
      //   state.subscriptionLoading = false;
      //   state.subscription = [];
      // })

      // // Delete subscription
      // .addCase(DeleteSubscriptionAction.fulfilled, (state, action) => {
      //   state.subscriptionLoading = false;
      //   state.subscription = action.payload.response;
      // })

      // //Update subscription
      // .addCase(UpdateSubscriptionAction.fulfilled, (state, action) => {
      //   state.subscriptionLoading = false;
      //   state.subscription = {
      //     ...state.subscription,
      //     data: state.subscription.data.map((item) =>
      //       item.id === action.payload.response.id
      //         ? action.payload.response
      //         : item
      //     ),
      //   };
      // })

      // //Add subscription
      // .addCase(AddSubscriptionAction.fulfilled, (state, action) => {
      //   state.subscriptionLoading = false;
      //   state.subscription = action.payload.response;
      // });
      .addCase(GetAllSubscriptionAction.pending, (state) => {
        state.subscriptionLoading = true;
      })
      .addCase(GetAllSubscriptionAction.fulfilled, (state, action) => {
        state.subscriptionLoading = false;
        state.subscription = action.payload.response || [];
      })
      .addCase(GetAllSubscriptionAction.rejected, (state) => {
        state.subscriptionLoading = false;
        state.subscription = [];
      })
      // DELETE subscription
      .addCase(DeleteSubscriptionAction.fulfilled, (state, action) => {
        state.subscriptionLoading = false;
        const deletedId = action.meta.arg.id; // ID passed when dispatching DeleteSubscriptionAction
        state.subscription = state.subscription.filter(
          (item) => item.id !== deletedId
        );
      })
      // UPDATE subscription
      .addCase(UpdateSubscriptionAction.fulfilled, (state, action) => {
        state.subscriptionLoading = false;
        const updated = action.payload.response;
        state.subscription = state.subscription.map((item) =>
          item.id === updated.id ? updated : item
        );
      })
      // ADD subscription
      .addCase(AddSubscriptionAction.fulfilled, (state, action) => {
        state.subscriptionLoading = false;
        const newPlan = action.payload.response;
        state.subscription.push(newPlan);
      })

      .addCase(GetAllPlanHistory.pending, (state) => {
        state.user =
          state.planHistory?.data?.length > 0 ? state.planHistory : null;
      })
      .addCase(GetAllPlanHistory.fulfilled, (state, action) => {
        state.planHistoryLoading = false;
        state.planHistory = action.payload.response || [];
      })
      .addCase(GetAllPlanHistory.rejected, (state) => {
        state.planHistoryLoading = false;
        state.planHistory = [];
      });
  },
});

export default SubscriptionPlanSlice.reducer;
